import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'
import type { PropertyEditorProps } from '@/lib/action-modules/registry/subtypes/types'

export default function BooleanPropertyEditor(props: PropertyEditorProps) {
  const { t } = useTranslation('action-modules-wizard')
  return (
    <Label className="flex items-center gap-2 font-normal">
      <Checkbox checked={props.value === true} onCheckedChange={c => props.onChanged(c === true)} />
      {t(props.property.displayNameKey)}
    </Label>
  )
}
